// Gancho da máscara enquanto digita (lista B de 30/10, item 4): aplica o formato ao texto do campo e devolve o cursor ao lugar
// certo, para digitar, apagar ou colar no meio do texto não jogar o cursor para o fim. As regras do formato são de nucleo/mascaras.ts.
import { useLayoutEffect, useRef, type ChangeEvent } from 'react';
import { aplicarMascara, type FormatoMascara, type LadoCursor } from '../nucleo/mascaras';

interface Pendente {
  alvo: HTMLInputElement;
  pos: number;
  em: number;
}

/**
 * Devolve o `onChange` do campo controlado. `valor` é o que o campo mostra agora; `aoMudarTexto` recebe o texto já com a máscara.
 * O React reescreve o valor do campo controlado e leva o cursor ao fim; a posição certa é aplicada logo depois do render (e,
 * se o texto não mudou e não houve render, ao fim do evento).
 */
export function useMascaraDigitando(opcoes: { formato: FormatoMascara; lado?: LadoCursor; valor: string; aoMudarTexto: (texto: string) => void }) {
  const pendente = useRef<Pendente | null>(null);
  const aplicar = (limpar: boolean) => {
    const p = pendente.current;
    if (!p) return;
    if (limpar) pendente.current = null;
    if (Date.now() - p.em > 300 || !p.alvo.isConnected || document.activeElement !== p.alvo) return;
    try {
      if (p.alvo.selectionStart !== p.pos || p.alvo.selectionEnd !== p.pos) p.alvo.setSelectionRange(p.pos, p.pos);
    } catch {
      /* tipo de campo sem seleção (number, email): sem cursor a acertar */
    }
  };
  useLayoutEffect(() => aplicar(true));
  return (e: ChangeEvent<HTMLInputElement>) => {
    const alvo = e.currentTarget;
    const bruto = alvo.value;
    const { texto, cursor } = aplicarMascara(bruto, alvo.selectionStart ?? bruto.length, opcoes.formato, { lado: opcoes.lado, anterior: opcoes.valor });
    pendente.current = { alvo, pos: cursor, em: Date.now() };
    opcoes.aoMudarTexto(texto);
    queueMicrotask(() => aplicar(false));
  };
}
